@if ({images: (slideViewerFacade.currentSelectedSlideValidImages$ | async), medias: (slideViewerFacade.currentSelectedSlideValidMedias$ | async), themeColor: (slideViewerFacade.themeColor$ | async), imageIndex: (slideViewerFacade.imageIndex$ | async)}; as imageData) {
  <div class="sequence-control"
    (wheel)="onWheel($event, imageData.imageIndex)"
    (touchstart)="onTouchStart($event)"
    (touchmove)="handleTouchMove($event, imageData.imageIndex)">
    <!-- Sequence Navigation -->
    @if ({sequenceItems: getSequenceItems(imageData.images, imageData.medias, imageData.themeColor, imageData.imageIndex) | sortBy_shared:'asc':'sequenceNumber', selectedImage: (slideViewerFacade.currentSelectedSlideImage$ | async)}; as sequenceData) {
      @if ((sequenceData.sequenceItems?.length ?? 0) > 1) {
        <div class="sequence-item-text">{{ getCurrentTitle(sequenceData.sequenceItems) }}</div>
      }
      <div class="sequence-navigation"
        [class.hidden]="imageData.images.length <= 1">
        @if (getSequenceControl(sequenceData.sequenceItems); as sequenceControl) {
          <!-- Sequence Up -->
          @if (sequenceControl) {
            <button class="sequence-arrow arrow-up"
              [tabIndex]="sequenceControl.up?.active ? 0 : -1"
              (click)="slideViewerFacade.requestSetImageIndex(imageData.imageIndex - 1)"
              [class.active]="sequenceControl.up?.active">
              <svg viewBox="0 0 24 12">
                <path d="M1 11 L23 11 L12 1Z"
                  [ngStyle]="{ fill: (menuSharedFacade.showMarkers$ | async) ? sequenceControl.up?.color : '' }">
                </path>
              </svg>
            </button>
          }
          <!-- Sequence Down -->
          @if (sequenceControl) {
            <button class="sequence-arrow arrow-down"
              [tabIndex]="sequenceControl.down?.active ? 0 : -1"
              (click)="slideViewerFacade.requestSetImageIndex(imageData.imageIndex + 1)"
              [class.active]="sequenceControl.down?.active">
              <svg viewBox="0 0 24 12">
                <path d="M1 1 L23 1 L12 11Z"
                  [ngStyle]="{ fill: (menuSharedFacade.showMarkers$ | async) ? sequenceControl.down?.color : '' }">
                </path>
              </svg>
            </button>
          }
        }
        <!-- List -->
        <div class="sequence-list"
          #sequenceList>
          @for (item of sequenceData.sequenceItems; track trackBy(i, item); let i = $index) {
            <button type="button"
              class="sequence-item"
              [class.active]="item.active"
              [class.hidden]="item.hidden"
              [ngStyle]="{ 'transform': 'rotateX(' + item.angle + 'deg)' }"
              [title]="item.title"
              (click)="slideViewerFacade.requestSetImageIndex(i)"
              [tabIndex]="item.hidden ? -1 : 0">
              <div class="sequence-item-indicator"
                [ngStyle]="{ background: (menuSharedFacade.showMarkers$ | async) ? item.color : '' }">
              </div>
            </button>
          }
        </div>
      </div>
    }
    <!-- Layer Navigation -->
    @if ({layers: (slideViewerFacade.currentSelectedSlideLayers$ | async) | sortBy_shared:'asc':'position', selectedLayer: (slideViewerFacade.currentSelectedSlideLayer$ | async)}; as layerData) {
      <div class="layer-navigation"
        >
        @if (layerData.layers.length > 1) {
          @for (layer of layerData.layers; track layer; let i = $index) {
            <button class="layer-item"
              [title]="layer.window ? ('enum.layer.' + layer.window | translate) : ('layer' | translate) + ' ' + (i + 1)"
              [ngClass]="{'active': layer === layerData.selectedLayer}"
              (click)="slideViewerFacade.requestSetLayerIndex(i)">
              {{ layer.window || 'L' + (i + 1) }}
            </button>
          }
        }
      </div>
    }
  </div>
}
